export { default } from './InputHint';
